import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class PurgeListService {
  apiUrl:string

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) { 
    this.apiUrl=this.config.getConfig('apiUrl')
  }

  errorHandler(error: HttpErrorResponse) {
    console.log("SERVICE ERROR", error)
    return throwError(error)
  }

  getPurgeList() {
    var payload = {
      duration: {
        year: 0,
        months: 0,
        days: 0
      }
    }
    return this.http.post<any>(this.apiUrl+`/compliance/purgelist/get`, payload)
  }

  approvePurge(data) {
    var payload = {
      docId: data
    }
    //console.log(payload)
    return this.http.put<any>(this.apiUrl+`/compliance/purgelist/approve`, payload)
      .pipe(catchError(this.errorHandler))
  }

}